export const ERROR_DELETE_QUOTA_SERVER = 'Failed to delete quota'
export const ERROR_GET_WA_TEMPLATES_SERVER = 'Failed to fetch WhatsApp templates from server'
export const ERROR_GET_WA_TEMPLATE_SERVER = 'Failed to fetch WhatsApp template from server'
export const ERROR_REFRESH_WA_TEMPLATE_SERVER = 'Failed to check for WhatsApp template updates from server'
export const ERROR_REGISTER_WA_TEMPLATE_SERVER = 'Failed to register WhatsApp template'
